import { aiAvatarThunks } from 'store/features/aiAvatar/thunks'
import { aiImageThunks } from 'store/features/aiImage/thunks'
import { aiVideoThunks } from 'store/features/aiVideo/thunks'
import { audioThunks } from 'store/features/audio/thunks'
import { cacheThunks } from 'store/features/cache/thunks'
import { creditsThunks } from 'store/features/credits/thunks'
import { editorThunks } from 'store/features/editor/thunks'
import { projectThunks } from 'store/features/project/thunks'
import { projectDataThunks } from 'store/features/projectData/thunks'
import { recentlyUsedMediaThunks } from 'store/features/recentlyUsedMedia/thunks'
import { ttsThunks } from 'store/features/tts/thunks'
import { userThunks } from 'store/features/user/thunks'
import { IAppThunksRegistry } from './types'

export const registerAppThunks = (registry: IAppThunksRegistry) => {
  registry.aiAvatarThunks = aiAvatarThunks
  registry.aiVideoThunks = aiVideoThunks
  registry.aiImageThunks = aiImageThunks
  registry.audioThunks = audioThunks
  registry.cacheThunks = cacheThunks
  registry.creditsThunks = creditsThunks
  registry.editorThunks = editorThunks
  registry.projectThunks = projectThunks
  registry.projectDataThunks = projectDataThunks
  registry.recentlyUsedMediaThunks = recentlyUsedMediaThunks
  registry.ttsThunks = ttsThunks
  registry.userThunks = userThunks
}

export default {
  aiAvatarThunks,
  aiVideoThunks,
  aiImageThunks,
  audioThunks,
  cacheThunks,
  creditsThunks,
  editorThunks,
  projectThunks,
  projectDataThunks,
  recentlyUsedMediaThunks,
  ttsThunks,
  userThunks
}
